import { render, staticRenderFns } from "./RoleResponsibilitiesTable.vue?vue&type=template&id=307ba2ec&scoped=true"
import script from "./RoleResponsibilitiesTable.vue?vue&type=script&lang=js"
export * from "./RoleResponsibilitiesTable.vue?vue&type=script&lang=js"
import style0 from "./RoleResponsibilitiesTable.vue?vue&type=style&index=0&id=307ba2ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307ba2ec",
  null
  
)

export default component.exports